import Button from '../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button/button-constants';
import Flex from '../../../generic/Flex';
import { icons } from '../../../generic/Icon/icons';
import type { GitAuth } from '../../../../../typings/auth';

type GitHeaderProps = { auth: GitAuth; onDelete: () => void };

const GitHeader = ({ auth, onDelete }: GitHeaderProps) => {
  const deleteButton = (
    <Button
      title="Delete"
      onClick={onDelete}
      icon={icons.trash}
      type={BUTTON_TYPE.ERROR}
      size={BUTTON_SIZE.SMALL}
    >
      Remove
    </Button>
  );

  const body = auth.displayName ?
      (
        <Flex justify="space-between" align="baseline">
          <h5 style={{ margin: 0 }}>{auth.displayName}</h5>
          {deleteButton}
        </Flex>
      ) :
        <div className="text-right">{deleteButton}</div>;

  return (
    <div className="margin-bottom-sm">
      {body}
    </div>
  );
};

export default GitHeader;
